/*
 * Copyright (c) 2019 Hawaii Information Consortium
 * 201 Merchant St #1805, Honolulu, HI 96813
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of Hawaii Information Consortium. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with HIC.
 */

export enum DealerLicenseStatus {

  ACTIVE,

  INACTIVE

}

export namespace DealerLicenseStatus {

  const MEANINGS = new Map<number, string>([
    [DealerLicenseStatus.ACTIVE, 'Active'],
    [DealerLicenseStatus.INACTIVE, 'Inactive']
  ]);

  export function meaning(status: DealerLicenseStatus) {
    return MEANINGS.get(status);
  }

  export function fromString(name: string): DealerLicenseStatus {
    return DealerLicenseStatus[name];
  }

}
